var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEffortlyLiveview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 166,
    viewBox: "0 0 386 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 382.707,
    height: 163.897,
    fill: "url(#pattern0_1_1593)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4132 36.5997V13.0799C4.4132 6.32681 10.517 0.855286 18.0505 0.855286H44.2882",
    stroke: "#A169D6",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384.276 36.5997V13.0799C384.276 6.32681 378.172 0.855286 370.638 0.855286H344.401",
    stroke: "#A169D6",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4132 107.062V130.582C4.4132 137.335 10.517 142.807 18.0505 142.807H44.2882",
    stroke: "#A169D6",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M384.276 107.062V130.582C384.276 137.335 378.172 142.807 370.638 142.807H344.401",
    stroke: "#A169D6",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.091 89.4831C203.48 89.4831 214.333 79.023 214.333 66.1198C214.333 53.2166 203.48 42.7565 190.091 42.7565C176.703 42.7565 165.85 53.2166 165.85 66.1198C165.85 79.023 176.703 89.4831 190.091 89.4831Z",
    fill: "url(#paint0_linear_1_1593)",
    stroke: "url(#paint1_linear_1_1593)",
    strokeWidth: 0.844828
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.666 60.7914V50.9542",
    stroke: "url(#paint2_linear_1_1593)",
    strokeWidth: 0.844828
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.666 81.2854V71.4482",
    stroke: "url(#paint3_linear_1_1593)",
    strokeWidth: 0.844828
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.62 65.71H205.827",
    stroke: "url(#paint4_linear_1_1593)",
    strokeWidth: 0.844828
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.355 65.71H184.562",
    stroke: "url(#paint5_linear_1_1593)",
    strokeWidth: 0.844828
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.757 19.0778C63.4197 19.0778 66.3888 16.6582 66.3888 13.6734C66.3888 10.6886 63.4197 8.26898 59.757 8.26898C56.0943 8.26898 53.1252 10.6886 53.1252 13.6734C53.1252 16.6582 56.0943 19.0778 59.757 19.0778Z",
    fill: "#FF3636"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.632 26.791H14.9072V42.1834H45.632V26.791Z",
    fill: "#9B96B0",
    fillOpacity: 0.73
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1587 13.2258C20.1587 12.3979 19.6856 11.8656 18.6329 11.8656H17.1426V14.6215H18.6329C19.6856 14.6215 20.1587 14.0419 20.1587 13.2258ZM15.7943 10.7657H18.6329C20.5845 10.7657 21.5425 11.8893 21.5425 13.2258C21.5425 14.1957 21.0221 15.2365 19.6383 15.5795L21.6726 18.9858H20.0641L18.1716 15.6978H17.1426V18.9858H15.7943V10.7657ZM27.8092 10.7538V11.8538H24.6157V14.2666H27.4544V15.3666H24.6157V17.8859H27.8092V18.9858H23.2674V10.7538H27.8092ZM29.0205 14.858C29.0205 12.3979 30.9011 10.6592 33.2193 10.6592C34.9343 10.6592 36.4127 11.5226 37.0396 13.1312H35.4192C34.9816 12.2559 34.201 11.842 33.2193 11.842C31.5871 11.842 30.4043 13.0011 30.4043 14.858C30.4043 16.7149 31.5871 17.8859 33.2193 17.8859C34.201 17.8859 34.9816 17.4719 35.4192 16.5967H37.0396C36.4127 18.2052 34.9343 19.0568 33.2193 19.0568C30.9011 19.0568 29.0205 17.33 29.0205 14.858Z",
    fill: "#9B96B0",
    fillOpacity: 0.73
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6938 39.8511V38.0533H21.4122V37.0361L25.3863 31.3352H27.0185V36.8823H28.1185V38.0533H27.0185V39.8511H25.6938ZM22.9616 36.8823H25.753V32.7072L22.9616 36.8823ZM33.9431 39.8511L30.7615 36.1727V39.8511H29.4131V31.6309H30.7615V35.3802L33.9549 31.6309H35.6463L32.0743 35.7469L35.7054 39.8511H33.9431Z",
    fill: "#2D2D2D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2612 39.8511V36.2555H54.3936V39.8511H53.0453V31.6309H54.3936V35.1555H58.2612V31.6309H59.6096V39.8511H58.2612ZM64.0695 31.6309C66.7071 31.6309 68.4339 33.2276 68.4339 35.7706C68.4339 38.3017 66.7071 39.8511 64.0695 39.8511H61.3846V31.6309H64.0695ZM62.733 38.7511H64.0695C66.0092 38.7511 67.0501 37.6393 67.0501 35.7706C67.0501 33.89 66.0092 32.7309 64.0695 32.7309H62.733V38.7511Z",
    fill: "#9B96B0",
    fillOpacity: 0.73
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M255.206 115.443V121.429",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M251.01 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M246.812 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M242.614 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M238.417 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M233.172 115.443V121.429",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M228.973 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M224.776 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M219.528 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M215.332 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M211.133 115.443V121.429",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M206.936 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M202.74 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M197.492 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M193.295 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M189.099 115.443V121.429",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M183.851 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M179.654 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M175.457 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M171.261 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M167.062 115.443V121.429",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M161.816 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M157.617 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M153.421 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M148.174 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M143.975 115.443V121.429",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M139.778 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M134.532 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M131.385 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M126.138 115.443V118.863",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M121.94 115.443V121.429",
    stroke: "#9B96B0",
    strokeWidth: 0.844828,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M188.575 110.312L192.248 105.181H184.902L188.575 110.312Z",
    fill: "#9B96B0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M164.609 130.49V129.724H167.887V130.49H164.609ZM165.016 144.994V140.009H164.274V139.18H165.933V144.994H165.016Z",
    fill: "#9B96B0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M141.523 130.49V129.724H144.801V130.49H141.523ZM141.236 144.914V144.252C142.607 143.048 144.051 141.995 144.051 140.855C144.051 140.249 143.788 139.834 143.11 139.834C142.472 139.834 142.129 140.281 142.105 140.935H141.228C141.26 139.674 142.073 139.06 143.102 139.06C144.282 139.06 144.952 139.77 144.952 140.815C144.952 142.227 143.517 143.303 142.583 144.157H145.112V144.914H141.236Z",
    fill: "#9B96B0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M119.486 130.49V129.724H122.764V130.49H119.486ZM119.255 140.616C119.318 139.611 120.1 139.044 121.161 139.044C122.317 139.044 122.947 139.714 122.947 140.56C122.947 141.254 122.508 141.724 122.054 141.876V141.908C122.66 142.091 123.051 142.593 123.051 143.399C123.051 144.324 122.397 145.026 121.185 145.026C120.084 145.026 119.231 144.452 119.175 143.311H120.052C120.092 143.853 120.491 144.268 121.177 144.268C121.854 144.268 122.189 143.853 122.189 143.311C122.189 142.546 121.695 142.282 120.746 142.282H120.539V141.533H120.754C121.575 141.525 122.078 141.285 122.078 140.663C122.078 140.161 121.751 139.826 121.129 139.826C120.491 139.826 120.196 140.209 120.14 140.616H119.255Z",
    fill: "#9B96B0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M187.479 130.011C187.479 128.352 187.925 127.076 189.552 127.076C191.179 127.076 191.626 128.352 191.626 130.011C191.626 131.702 191.179 132.978 189.552 132.978C187.925 132.978 187.479 131.702 187.479 130.011ZM190.733 130.011C190.733 128.927 190.613 127.906 189.552 127.906C188.492 127.906 188.372 128.927 188.372 130.011C188.372 131.152 188.492 132.149 189.552 132.149C190.613 132.149 190.733 131.152 190.733 130.011Z",
    fill: "#9B96B0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M210.41 128.081H211.255V129.732H212.866V130.498H211.255V132.149H210.41V130.498H208.799V129.732H210.41V128.081ZM209.086 144.994V140.009H208.344V139.18H210.003V144.994H209.086Z",
    fill: "#9B96B0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M232.447 128.081H233.292V129.732H234.903V130.498H233.292V132.149H232.447V130.498H230.836V129.732H232.447V128.081ZM230.429 144.914V144.252C231.801 143.048 233.244 141.995 233.244 140.855C233.244 140.249 232.981 139.834 232.303 139.834C231.665 139.834 231.322 140.281 231.298 140.935H230.421C230.453 139.674 231.267 139.06 232.295 139.06C233.476 139.06 234.146 139.77 234.146 140.815C234.146 142.227 232.71 143.303 231.777 144.157H234.305V144.914H230.429Z",
    fill: "#9B96B0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M254.483 128.081H255.328V129.732H256.939V130.498H255.328V132.149H254.483V130.498H252.872V129.732H254.483V128.081ZM252.521 140.616C252.585 139.611 253.367 139.044 254.427 139.044C255.584 139.044 256.214 139.714 256.214 140.56C256.214 141.254 255.775 141.724 255.32 141.876V141.908C255.927 142.091 256.317 142.593 256.317 143.399C256.317 144.324 255.663 145.026 254.451 145.026C253.351 145.026 252.497 144.452 252.441 143.311H253.319C253.359 143.853 253.757 144.268 254.443 144.268C255.121 144.268 255.456 143.853 255.456 143.311C255.456 142.546 254.962 142.282 254.013 142.282H253.805V141.533H254.02C254.842 141.525 255.344 141.285 255.344 140.663C255.344 140.161 255.017 139.826 254.395 139.826C253.757 139.826 253.462 140.209 253.406 140.616H252.521Z",
    fill: "#9B96B0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_1593",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_1593",
    transform: "scale(0.000684932 0.00158983)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1593",
    x1: 190.091,
    y1: 42.7565,
    x2: 190.091,
    y2: 89.4831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1593",
    x1: 165.85,
    y1: 66.1198,
    x2: 214.333,
    y2: 66.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B68DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D668CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1593",
    x1: 189.666,
    y1: 55.8728,
    x2: 190.666,
    y2: 55.8728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B68DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D668CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1593",
    x1: 189.666,
    y1: 76.3668,
    x2: 190.666,
    y2: 76.3668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B68DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D668CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_1593",
    x1: 195.62,
    y1: 66.21,
    x2: 205.827,
    y2: 66.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B68DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D668CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_1593",
    x1: 174.355,
    y1: 66.21,
    x2: 184.562,
    y2: 66.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B68DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D668CF"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_1593",
    width: 1460,
    height: 629,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffortlyLiveview);
export default __webpack_public_path__ + "static/media/effortly-liveview.4b3ce99514be4c18012d89f18249d4ae.svg";
export { ForwardRef as ReactComponent };